import {
    TEST,
    SET_MOBILE_NAV_STATUS,
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    SET_TOPUP_MODAL_STATUS,
    GET_DIRECT_TOPUP_INFO_STARTED,
    GET_DIRECT_TOPUP_INFO_SUCCESS,
    GET_DIRECT_TOPUP_INFO_FAILURE,
    CREATE_DIRECT_TOPUP_STARTED,
    CREATE_DIRECT_TOPUP_SUCCESS,
    CREATE_DIRECT_TOPUP_FAILURE,
    GET_DIRECT_TOPUP_STARTED,
    GET_DIRECT_TOPUP_SUCCESS,
    GET_DIRECT_TOPUP_FAILURE,
    CANCEL_DIRECT_TOPUP_STARTED,
    CANCEL_DIRECT_TOPUP_SUCCESS,
    CANCEL_DIRECT_TOPUP_FAILURE,
    GET_DASHBOARD_STARTED,
    GET_DASHBOARD_SUCCESS,
    GET_DASHBOARD_FAILURE,
    GET_SYSTEM_UPDATES_STARTED,
    GET_SYSTEM_UPDATES_SUCCESS,
    GET_SYSTEM_UPDATES_FAILURE,
    GET_NOTIFICATIONS_STARTED,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAILURE,
    READ_NOTIFICATION_SUCCESS,
    READ_ALL_NOTIFICATIONS_SUCCESS,
    GET_WITHDRAW_INFO_STARTED,
    GET_WITHDRAW_INFO_SUCCESS,
    GET_WITHDRAW_INFO_FAILURE,
    CREATE_WITHDRAW_STARTED,
    CREATE_WITHDRAW_SUCCESS,
    CREATE_WITHDRAW_FAILURE,
    GET_WITHDRAWS_STARTED,
    GET_WITHDRAWS_SUCCESS,
    GET_WITHDRAWS_FAILURE,
    CANCEL_WITHDRAW_STARTED,
    CANCEL_WITHDRAW_SUCCESS,
    CANCEL_WITHDRAW_FAILURE,
    SET_WITHDRAW_MODAL_STATUS,
    SET_REFERRAL_WITHDRAW_MODAL_STATUS,
    GET_REFERRAL_WITHDRAW_INFO_STARTED,
    GET_REFERRAL_WITHDRAW_INFO_SUCCESS,
    GET_REFERRAL_WITHDRAW_INFO_FAILURE,
    CREATE_REFERRAL_WITHDRAW_STARTED,
    CREATE_REFERRAL_WITHDRAW_SUCCESS,
    CREATE_REFERRAL_WITHDRAW_FAILURE,
    GET_REFERRAL_WITHDRAWS_STARTED,
    GET_REFERRAL_WITHDRAWS_SUCCESS,
    GET_REFERRAL_WITHDRAWS_FAILURE,
    CANCEL_REFERRAL_WITHDRAW_STARTED,
    CANCEL_REFERRAL_WITHDRAW_SUCCESS,
    GET_REFERRAL_TRANSFERS_STARTED,
    GET_REFERRAL_TRANSFERS_SUCCESS,
    GET_REFERRAL_TRANSFERS_FAILURE,
    CREATE_REFERRAL_TRANSFER_STARTED,
    CREATE_REFERRAL_TRANSFER_SUCCESS,
    CREATE_REFERRAL_TRANSFER_FAILURE,
    CANCEL_REFERRAL_TRANSFER_STARTED,
    CANCEL_REFERRAL_TRANSFER_SUCCESS,
    CANCEL_REFERRAL_TRANSFER_FAILURE,
    SET_REFERRAL_TRANSFER_MODAL_STATUS,
    SET_REFERRAL_TRANSFERS_MODAL_STATUS,
    REQUEST_EARLY_ACCESS_STARTED,
    REQUEST_EARLY_ACCESS_SUCCESS,
    REQUEST_EARLY_ACCESS_FAILURE,
    SET_STORAGE_MODAL_STATUS,
    GET_STORAGE_STARTED,
    GET_STORAGE_SUCCESS,
    GET_STORAGE_FAILURE,
    GET_STORAGE_PACKAGES_STARTED,
    GET_STORAGE_PACKAGES_SUCCESS,
    GET_STORAGE_PACKAGES_FAILURE,
    CREATE_STORAGE_PURCHASE_STARTED,
    CREATE_STORAGE_PURCHASE_SUCCESS,
    CREATE_STORAGE_PURCHASE_FAILURE,
    GET_STORAGE_PURCHASE_SUCCESS,
    CANCEL_STORAGE_PURCHASE_SUCCESS,
    GET_AVATAR_STARTED,
    GET_AVATAR_SUCCESS,
    GET_AVATAR_FAILURE,
    GET_VOICE_STARTED,
    GET_VOICE_SUCCESS,
    GET_VOICE_FAILURE,
    UPLOAD_VOICE_STARTED,
    UPLOAD_VOICE_SUCCESS,
    UPLOAD_VOICE_FAILURE,
    GET_ENERGY_STARTED,
    GET_ENERGY_SUCCESS,
    GET_ENERGY_FAILURE,
    UNLOCK_ENERGY_STARTED,
    UNLOCK_ENERGY_SUCCESS,
    UNLOCK_ENERGY_FAILURE,
    GET_METAPERSON_STARTED,
    GET_METAPERSON_SUCCESS,
    GET_METAPERSON_FAILURE,
    IMPORT_AVATAR_STARTED,
    IMPORT_AVATAR_SUCCESS,
    IMPORT_AVATAR_FAILURE,
    GET_ENERGY_PACKAGES_STARTED,
    GET_ENERGY_PACKAGES_SUCCESS,
    GET_ENERGY_PACKAGES_FAILURE,
    CREATE_ENERGY_PURCHASE_STARTED,
    CREATE_ENERGY_PURCHASE_SUCCESS,
    CREATE_ENERGY_PURCHASE_FAILURE,
    GET_ENERGY_PURCHASE_SUCCESS,
    CANCEL_ENERGY_PURCHASE_SUCCESS,
    ASK_CONVERSATION_STARTED,
    ASK_CONVERSATION_SUCCESS,
    ASK_CONVERSATION_FAILURE,
    SPEAK_CONVERSATION_STARTED,
    SPEAK_CONVERSATION_SUCCESS,
    SPEAK_CONVERSATION_FAILURE,
    GET_CONVERSATIONS_STARTED,
    GET_CONVERSATIONS_SUCCESS,
    GET_CONVERSATIONS_FAILURE,
    GET_CONVERSATION_STARTED,
    GET_CONVERSATION_SUCCESS,
    GET_CONVERSATION_FAILURE,
    SEAL_CAPSULE_STARTED,
    SEAL_CAPSULE_SUCCESS,
    SEAL_CAPSULE_FAILURE,
    SET_SEAL_MODAL_STATUS,
    SET_UNLOCK_MODAL_STATUS,
    SET_ENERGY_MODAL_STATUS,
    SET_CREATOR_STATUS,
    CREATE_TOPUP_STARTED,
    CREATE_TOPUP_SUCCESS,
    CREATE_TOPUP_FAILURE,
    GET_TOPUP_STATUS_STARTED,
    GET_TOPUP_STATUS_SUCCESS,
    GET_TOPUP_STATUS_FAILURE,
    CANCEL_TOPUP_STARTED,
    CANCEL_TOPUP_SUCCESS,
    CANCEL_TOPUP_FAILURE,
    GET_PRE_SALE_MAIN_STARTED,
    GET_PRE_SALE_MAIN_SUCCESS,
    GET_PRE_SALE_MAIN_FAILURE,
    SET_PRE_SALE_BUY_MODAL_STATUS,
    SET_SETTINGS_CHANGE_PASSWORD_MODAL_STATUS,
    CHANGE_PASSWORD_STARTED,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    SET_SETTINGS_CHANGE_WALLET_MODAL_STATUS,
    CHANGE_WALLET_STARTED,
    CHANGE_WALLET_SUCCESS,
    CHANGE_WALLET_FAILURE,
    GET_BUY_TOKEN_DATA_STARTED,
    GET_BUY_TOKEN_DATA_SUCCESS,
    GET_BUY_TOKEN_DATA_FAILURE,
    SET_SETTINGS_CHANGE_EMAIL_MODAL_STATUS,
    CHANGE_EMAIL_STARTED,
    CHANGE_EMAIL_SUCCESS,
    CHANGE_EMAIL_FAILURE,
    GET_LAST_LOG_STARTED,
    GET_LAST_LOG_SUCCESS,
    GET_LAST_LOG_FAILURE,
    LOGOUT_STARTED,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    LOGOUT_OTHERS_STARTED,
    LOGOUT_OTHERS_SUCCESS,
    LOGOUT_OTHERS_FAILURE,
    GET_ORDER_HISTORY_STARTED,
    GET_ORDER_HISTORY_SUCCESS,
    GET_ORDER_HISTORY_FAILURE,
    GET_ACTIVE_ORDER_STARTED,
    GET_ACTIVE_ORDER_SUCCESS,
    GET_ACTIVE_ORDER_FAILURE,
    CANCEL_ORDER_STARTED,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_FAILURE,
    GET_REFERRALS_STARTED,
    GET_REFERRALS_SUCCESS,
    GET_REFERRALS_FAILURE,
    SET_REFERRER_STARTED,
    SET_REFERRER_SUCCESS,
    SET_REFERRER_FAILURE,
    SET_CAPSULE_QUESTIONNAIRE_MODAL_STATUS,
    SET_CAPSULE_NOTES_MODAL_STATUS,
    SET_CAPSULE_FILES_MODAL_STATUS,
    SET_CAPSULE_BUY_MODAL_STATUS,
    GET_CAPSULE_OFFER_STARTED,
    GET_CAPSULE_OFFER_SUCCESS,
    GET_CAPSULE_OFFER_FAILURE,
    PURCHASE_CAPSULE_STARTED,
    PURCHASE_CAPSULE_SUCCESS,
    PURCHASE_CAPSULE_FAILURE,
    GET_CAPSULE_STATS_STARTED,
    GET_CAPSULE_STATS_SUCCESS,
    GET_CAPSULE_STATS_FAILURE,
    GET_QUESTIONNAIRE_STARTED,
    GET_QUESTIONNAIRE_SUCCESS,
    GET_QUESTIONNAIRE_FAILURE,
    SAVE_BLOCK_ANSWERS_STARTED,
    SAVE_BLOCK_ANSWERS_SUCCESS,
    SAVE_BLOCK_ANSWERS_FAILURE,
    GET_CAPSULE_NOTES_STARTED,
    GET_CAPSULE_NOTES_SUCCESS,
    GET_CAPSULE_NOTES_FAILURE,
    SAVE_CAPSULE_NOTE_STARTED,
    SAVE_CAPSULE_NOTE_SUCCESS,
    SAVE_CAPSULE_NOTE_FAILURE,
    DELETE_CAPSULE_NOTE_STARTED,
    DELETE_CAPSULE_NOTE_SUCCESS,
    DELETE_CAPSULE_NOTE_FAILURE,
    GET_CAPSULE_FILES_STARTED,
    GET_CAPSULE_FILES_SUCCESS,
    GET_CAPSULE_FILES_FAILURE,
    UPLOAD_CAPSULE_FILE_STARTED,
    UPLOAD_CAPSULE_FILE_SUCCESS,
    UPLOAD_CAPSULE_FILE_FAILURE,
    SET_CAPSULE_FILE_UPLOAD_PROGRESS,
    DELETE_CAPSULE_FILE_STARTED,
    DELETE_CAPSULE_FILE_SUCCESS,
    DELETE_CAPSULE_FILE_FAILURE
} from "./types";


const initialState = {
    test: false,
    mobileNavStatus: false,
    userDataStarted: false,
    userData: false,
    userDataErr: false,

    topUpModalStatus: false,

    directTopUpInfoStarted: false,
    directTopUpInfo: false,
    directTopUpInfoErr: false,

    createDirectTopUpStarted: false,
    directTopUp: false,
    createDirectTopUpErr: false,

    directTopUpStarted: false,
    cancelDirectTopUpStarted: false,

    dashboardStarted: false,
    dashboard: false,
    dashboardErr: false,

    systemUpdatesStarted: false,
    systemUpdates: false,
    systemUpdatesErr: false,

    notificationsStarted: false,
    notifications: false,
    notificationsErr: false,

    withdrawModalStatus: false,

    withdrawInfoStarted: false,
    withdrawInfo: false,
    withdrawInfoErr: false,

    createWithdrawStarted: false,
    createWithdrawStatus: false,
    createWithdrawErr: false,

    withdrawsStarted: false,
    withdraws: false,

    referralWithdrawModalStatus: false,
    referralWithdrawInfoStarted: false,
    referralWithdrawInfo: false,
    referralWithdrawInfoErr: false,

    createReferralWithdrawStarted: false,
    createReferralWithdrawStatus: false,
    createReferralWithdrawErr: false,

    referralWithdrawsStarted: false,
    referralWithdraws: false,

    cancelReferralWithdrawStarted: false,

    referralTransferModalStatus: false,
    referralTransfersModalStatus: false,

    referralTransfersStarted: false,
    referralTransfers: false,

    createReferralTransferStarted: false,
    createReferralTransferErr: false,

    cancelReferralTransferStarted: false,

    earlyAccessStarted: false,
    earlyAccessErr: false,

    storageModalStatus: false,
    storageStarted: false,
    storageData: false,
    storagePackagesStarted: false,
    storagePackages: false,
    storagePurchaseStarted: false,
    storagePurchase: false,
    storagePurchaseErr: false,

    avatarStarted: false,
    avatar: false,
    avatarErr: false,

    voiceStarted: false,
    voice: false,
    voiceErr: false,

    uploadVoiceStarted: false,
    uploadVoiceErr: false,

    energyStarted: false,
    energy: false,
    unlockStarted: false,
    unlockErr: false,

    metapersonStarted: false,
    metaperson: false,
    metapersonErr: false,

    importAvatarStarted: false,
    importAvatarErr: false,

    unlockModalStatus: false,
    energyModalStatus: false,
    // окно MetaPerson открыто
    creatorStatus: false,

    energyPackagesStarted: false,
    energyPackages: false,

    energyPurchaseStarted: false,
    // текущий счёт на покупку энергии
    energyPurchase: false,
    energyPurchaseErr: false,

    askStarted: false,
    askErr: false,
    speakStarted: false,

    conversationsStarted: false,
    conversations: false,
    conversationStarted: false,
    conversation: false,

    sealStarted: false,
    sealErr: false,
    sealModalStatus: false,

    cancelWithdrawStarted: false,

    createTopUpStarted: false,
    createTopUpStatus: false,
    createTopUpErr: false,

    topUpStatusStarted: false,
    topUpStatus: false,
    topUpStatusErr: false,

    cancelTopUpStarted: false,
    cancelTopUpStatus: false,
    cancelTopUpErr: false,
    preSaleMainStatusStarted: false,
    preSaleMainStatus: false,
    preSaleMainStatusErr: false,
    preSaleBuyModalStatus: false,
    settingsChangePasswordModalStatus: false,
    settingsChangeWalletModalStatus: false,
    changePasswordStatusStarted: false,
    changePasswordStatus: false,
    changePasswordStatusErr: false,
    changeWalletStatusStarted: false,
    changeWalletStatus: false,
    changeWalletStatusErr: false,
    buyTokenDataStarted: false,
    buyTokenData: false,
    buyTokenDataErr: false,
    settingsChangeEmailModalStatus: false,
    changeEmailStatusStarted: false,
    changeEmailStatus: false,
    changeEmailStatusErr: false,
    lastLogStarted: false,
    lastLog: false,
    lastLogErr: false,
    logoutStatusStarted: false,
    logoutStatus: false,
    logoutStatusErr: false,
    logoutOthersStatusStarted: false,
    logoutOthersStatus: false,
    logoutOthersStatusErr: false,
    orderHistoryStarted: false,
    orderHistory: false,
    orderHistoryErr: false,
    activeOrderStarted: false,
    activeOrder: false,
    activeOrderErr: false,
    cancelOrderStatusStarted: false,
    cancelOrderStatus: false,
    cancelOrderStatusErr: false,
    referralsStarted: false,
    referrals: false,
    referralsErr: false,
    setReferrerStarted: false,
    setReferrerErr: false,

    capsuleQuestionnaireModalStatus: false,
    capsuleNotesModalStatus: false,
    capsuleFilesModalStatus: false,
    capsuleBuyModalStatus: false,

    capsuleOfferStarted: false,
    capsuleOffer: false,
    capsuleOfferErr: false,

    purchaseCapsuleStarted: false,
    purchaseCapsuleStatus: false,
    purchaseCapsuleErr: false,

    capsuleStatsStarted: false,
    capsuleStats: false,
    capsuleStatsErr: false,

    questionnaireStarted: false,
    questionnaire: false,
    questionnaireErr: false,

    saveBlockAnswersStarted: false,
    saveBlockAnswersStatus: false,
    saveBlockAnswersErr: false,

    capsuleNotesStarted: false,
    capsuleNotes: false,
    capsuleNotesErr: false,

    saveCapsuleNoteStarted: false,
    saveCapsuleNoteStatus: false,
    saveCapsuleNoteErr: false,

    deleteCapsuleNoteStarted: false,
    deleteCapsuleNoteStatus: false,
    deleteCapsuleNoteErr: false,

    capsuleFilesStarted: false,
    capsuleFiles: false,
    capsuleFilesErr: false,

    uploadCapsuleFileStarted: false,
    uploadCapsuleFileStatus: false,
    uploadCapsuleFileErr: false,
    capsuleFileUploadProgress: false,

    deleteCapsuleFileStarted: false,
    deleteCapsuleFileStatus: false,
    deleteCapsuleFileErr: false,
};

export function cabinetReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_MOBILE_NAV_STATUS:
            return {
                ...state,
                mobileNavStatus: action.payload
            };
        case GET_USER_DATA_STARTED:
            return {
                ...state,
                userDataStarted: true
            };
        case GET_USER_DATA_SUCCESS:
            return {
                ...state,
                userData: action.payload,
                userDataStarted: false
            };
        case GET_USER_DATA_FAILURE:
            return {
                ...state,
                userDataErr: action.payload,
                userDataStarted: false
            };
        case GET_PRE_SALE_MAIN_STARTED:
            return {
                ...state,
                preSaleMainStatusStarted: true
            };
        case GET_PRE_SALE_MAIN_SUCCESS:
            return {
                ...state,
                preSaleMainStatus: action.payload,
                preSaleMainStatusStarted: false
            };
        case GET_PRE_SALE_MAIN_FAILURE:
            return {
                ...state,
                preSaleMainStatusErr: action.payload,
                preSaleMainStatusStarted: false
            };
        case SET_PRE_SALE_BUY_MODAL_STATUS:
            return {
                ...state,
                preSaleBuyModalStatus: action.payload
            };
        case SET_SETTINGS_CHANGE_PASSWORD_MODAL_STATUS:
            return {
                ...state,
                settingsChangePasswordModalStatus: action.payload
            };
        case CHANGE_PASSWORD_STARTED:
            return {
                ...state,
                changePasswordStatusStarted: true
            };
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                changePasswordStatus: action.payload,
                changePasswordStatusStarted: false
            };
        case CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                changePasswordStatusErr: action.payload,
                changePasswordStatusStarted: false
            };
        case SET_SETTINGS_CHANGE_WALLET_MODAL_STATUS:
            return {
                ...state,
                settingsChangeWalletModalStatus: action.payload
            };
        case CHANGE_WALLET_STARTED:
            return {
                ...state,
                changeWalletStatusStarted: true
            };
        case CHANGE_WALLET_SUCCESS:
            return {
                ...state,
                changeWalletStatus: action.payload,
                changeWalletStatusStarted: false
            };
        case CHANGE_WALLET_FAILURE:
            return {
                ...state,
                changeWalletStatusErr: action.payload,
                changeWalletStatusStarted: false
            };
        case GET_BUY_TOKEN_DATA_STARTED:
            return {
                ...state,
                buyTokenDataStarted: true
            };
        case GET_BUY_TOKEN_DATA_SUCCESS:
            return {
                ...state,
                buyTokenData: action.payload,
                buyTokenDataStarted: false
            };
        case GET_BUY_TOKEN_DATA_FAILURE:
            return {
                ...state,
                buyTokenDataErr: action.payload,
                buyTokenDataStarted: false
            };
        case SET_SETTINGS_CHANGE_EMAIL_MODAL_STATUS:
            return {
                ...state,
                settingsChangeEmailModalStatus: action.payload
            };
        case CHANGE_EMAIL_STARTED:
            return {
                ...state,
                changeEmailStatusStarted: true
            };
        case CHANGE_EMAIL_SUCCESS:
            return {
                ...state,
                changeEmailStatus: action.payload,
                changeEmailStatusStarted: false
            };
        case CHANGE_EMAIL_FAILURE:
            return {
                ...state,
                changeEmailStatusErr: action.payload,
                changeEmailStatusStarted: false
            };
        case GET_LAST_LOG_STARTED:
            return {
                ...state,
                lastLogStarted: true
            };
        case GET_LAST_LOG_SUCCESS:
            return {
                ...state,
                lastLog: action.payload,
                lastLogStarted: false
            };
        case GET_LAST_LOG_FAILURE:
            return {
                ...state,
                lastLogErr: action.payload,
                lastLogStarted: false
            };
        case LOGOUT_STARTED:
            return {
                ...state,
                logoutStatusStarted: true
            };
        case LOGOUT_SUCCESS:
            return {
                ...state,
                logoutStatus: action.payload,
                logoutStatusStarted: false
            };
        case LOGOUT_FAILURE:
            return {
                ...state,
                logoutStatusErr: action.payload,
                logoutStatusStarted: false
            };
        case LOGOUT_OTHERS_STARTED:
            return {
                ...state,
                logoutOthersStatusStarted: true
            };
        case LOGOUT_OTHERS_SUCCESS:
            return {
                ...state,
                logoutOthersStatus: action.payload,
                logoutOthersStatusStarted: false
            };
        case LOGOUT_OTHERS_FAILURE:
            return {
                ...state,
                logoutOthersStatusErr: action.payload,
                logoutOthersStatusStarted: false
            };
        case GET_ORDER_HISTORY_STARTED:
            return {
                ...state,
                orderHistoryStarted: true
            };
        case GET_ORDER_HISTORY_SUCCESS:
            return {
                ...state,
                orderHistory: action.payload,
                orderHistoryStarted: false
            };
        case GET_ORDER_HISTORY_FAILURE:
            return {
                ...state,
                orderHistoryErr: action.payload,
                orderHistoryStarted: false
            };
        case GET_ACTIVE_ORDER_STARTED:
            return {
                ...state,
                activeOrderStarted: true
            };
        case GET_ACTIVE_ORDER_SUCCESS:
            return {
                ...state,
                activeOrder: action.payload,
                activeOrderStarted: false
            };
        case GET_ACTIVE_ORDER_FAILURE:
            return {
                ...state,
                activeOrderErr: action.payload,
                activeOrderStarted: false
            };
        case CANCEL_ORDER_STARTED:
            return {
                ...state,
                cancelOrderStatusStarted: true
            };
        case CANCEL_ORDER_SUCCESS:
            return {
                ...state,
                cancelOrderStatus: action.payload,
                cancelOrderStatusStarted: false
            };
        case CANCEL_ORDER_FAILURE:
            return {
                ...state,
                cancelOrderStatusErr: action.payload,
                cancelOrderStatusStarted: false
            };
        case GET_REFERRALS_STARTED:
            return {
                ...state,
                referralsStarted: true
            };
        case GET_REFERRALS_SUCCESS:
            return {
                ...state,
                referrals: action.payload,
                referralsStarted: false
            };
        case GET_REFERRALS_FAILURE:
            return {
                ...state,
                referralsErr: action.payload,
                referralsStarted: false
            };

        case SET_REFERRER_STARTED:
            return {
                ...state,
                setReferrerStarted: true,
                setReferrerErr: false
            }

        case SET_REFERRER_SUCCESS:
            return {
                ...state,
                setReferrerStarted: false,
                setReferrerErr: false
            }

        case SET_REFERRER_FAILURE:
            return {
                ...state,
                setReferrerErr: action.payload,
                setReferrerStarted: false
            }
        case SET_CAPSULE_QUESTIONNAIRE_MODAL_STATUS:
            return {
                ...state,
                capsuleQuestionnaireModalStatus: action.payload
            };
        case SET_CAPSULE_NOTES_MODAL_STATUS:
            return {
                ...state,
                capsuleNotesModalStatus: action.payload
            };
        case SET_CAPSULE_FILES_MODAL_STATUS:
            return {
                ...state,
                capsuleFilesModalStatus: action.payload
            };
        case SET_CAPSULE_BUY_MODAL_STATUS:
            return {
                ...state,
                capsuleBuyModalStatus: action.payload
            };
        case SET_CAPSULE_FILE_UPLOAD_PROGRESS:
            return {
                ...state,
                capsuleFileUploadProgress: action.payload
            };
        case GET_CAPSULE_STATS_STARTED:
            return {
                ...state,
                capsuleStatsStarted: true
            };
        case GET_CAPSULE_STATS_SUCCESS:
            return {
                ...state,
                capsuleStats: action.payload,
                capsuleStatsStarted: false
            };
        case GET_CAPSULE_STATS_FAILURE:
            return {
                ...state,
                capsuleStatsErr: action.payload,
                capsuleStatsStarted: false
            };
        case GET_QUESTIONNAIRE_STARTED:
            return {
                ...state,
                questionnaireStarted: true
            };
        case GET_QUESTIONNAIRE_SUCCESS:
            return {
                ...state,
                questionnaire: action.payload,
                questionnaireStarted: false
            };
        case GET_QUESTIONNAIRE_FAILURE:
            return {
                ...state,
                questionnaireErr: action.payload,
                questionnaireStarted: false
            };
        case SAVE_BLOCK_ANSWERS_STARTED:
            return {
                ...state,
                saveBlockAnswersStarted: true
            };
        case SAVE_BLOCK_ANSWERS_SUCCESS:
            return {
                ...state,
                saveBlockAnswersStatus: action.payload,
                saveBlockAnswersStarted: false
            };
        case SAVE_BLOCK_ANSWERS_FAILURE:
            return {
                ...state,
                saveBlockAnswersErr: action.payload,
                saveBlockAnswersStarted: false
            };
        case GET_CAPSULE_NOTES_STARTED:
            return {
                ...state,
                capsuleNotesStarted: true
            };
        case GET_CAPSULE_NOTES_SUCCESS:
            return {
                ...state,
                capsuleNotes: action.payload,
                capsuleNotesStarted: false
            };
        case GET_CAPSULE_NOTES_FAILURE:
            return {
                ...state,
                capsuleNotesErr: action.payload,
                capsuleNotesStarted: false
            };
        case SAVE_CAPSULE_NOTE_STARTED:
            return {
                ...state,
                saveCapsuleNoteStarted: true
            };
        case SAVE_CAPSULE_NOTE_SUCCESS:
            return {
                ...state,
                saveCapsuleNoteStatus: action.payload,
                saveCapsuleNoteStarted: false
            };
        case SAVE_CAPSULE_NOTE_FAILURE:
            return {
                ...state,
                saveCapsuleNoteErr: action.payload,
                saveCapsuleNoteStarted: false
            };
        case DELETE_CAPSULE_NOTE_STARTED:
            return {
                ...state,
                deleteCapsuleNoteStarted: true
            };
        case DELETE_CAPSULE_NOTE_SUCCESS:
            return {
                ...state,
                deleteCapsuleNoteStatus: action.payload,
                deleteCapsuleNoteStarted: false
            };
        case DELETE_CAPSULE_NOTE_FAILURE:
            return {
                ...state,
                deleteCapsuleNoteErr: action.payload,
                deleteCapsuleNoteStarted: false
            };
        case GET_CAPSULE_FILES_STARTED:
            return {
                ...state,
                capsuleFilesStarted: true
            };
        case GET_CAPSULE_FILES_SUCCESS:
            return {
                ...state,
                capsuleFiles: action.payload,
                capsuleFilesStarted: false
            };
        case GET_CAPSULE_FILES_FAILURE:
            return {
                ...state,
                capsuleFilesErr: action.payload,
                capsuleFilesStarted: false
            };
        case UPLOAD_CAPSULE_FILE_STARTED:
            return {
                ...state,
                uploadCapsuleFileStarted: true
            };
        case UPLOAD_CAPSULE_FILE_SUCCESS:
            return {
                ...state,
                uploadCapsuleFileStatus: action.payload,
                uploadCapsuleFileStarted: false
            };
        case UPLOAD_CAPSULE_FILE_FAILURE:
            return {
                ...state,
                uploadCapsuleFileErr: action.payload,
                uploadCapsuleFileStarted: false
            };
        case DELETE_CAPSULE_FILE_STARTED:
            return {
                ...state,
                deleteCapsuleFileStarted: true
            };
        case DELETE_CAPSULE_FILE_SUCCESS:
            return {
                ...state,
                deleteCapsuleFileStatus: action.payload,
                deleteCapsuleFileStarted: false
            };
        case DELETE_CAPSULE_FILE_FAILURE:
            return {
                ...state,
                deleteCapsuleFileErr: action.payload,
                deleteCapsuleFileStarted: false
            };
        case GET_CAPSULE_OFFER_STARTED:
            return {
                ...state,
                capsuleOfferStarted: true
            };
        case GET_CAPSULE_OFFER_SUCCESS:
            return {
                ...state,
                capsuleOffer: action.payload,
                capsuleOfferStarted: false
            };
        case GET_CAPSULE_OFFER_FAILURE:
            return {
                ...state,
                capsuleOfferErr: action.payload,
                capsuleOfferStarted: false
            };
        case PURCHASE_CAPSULE_STARTED:
            return {
                ...state,
                purchaseCapsuleStarted: true
            };
        case PURCHASE_CAPSULE_SUCCESS:
            return {
                ...state,
                purchaseCapsuleStatus: action.payload,
                purchaseCapsuleErr: false,
                purchaseCapsuleStarted: false
            };
        case PURCHASE_CAPSULE_FAILURE:
            return {
                ...state,
                purchaseCapsuleErr: action.payload,
                purchaseCapsuleStarted: false
            };
        case SET_TOPUP_MODAL_STATUS:
            return {
                ...state,
                topUpModalStatus: action.payload
            };
        case GET_DASHBOARD_STARTED:
            return {
                ...state,
                dashboardStarted: true
            };
        case GET_DASHBOARD_SUCCESS:
            return {
                ...state,
                dashboard: action.payload,
                dashboardStarted: false
            };
        case GET_DASHBOARD_FAILURE:
            return {
                ...state,
                dashboardErr: action.payload,
                dashboardStarted: false
            };
        case CREATE_TOPUP_STARTED:
            return {
                ...state,
                createTopUpStarted: true
            };
        case CREATE_TOPUP_SUCCESS:
            return {
                ...state,
                createTopUpStatus: action.payload,
                createTopUpStarted: false
            };
        case CREATE_TOPUP_FAILURE:
            return {
                ...state,
                createTopUpErr: action.payload,
                createTopUpStarted: false
            };
        case GET_TOPUP_STATUS_STARTED:
            return {
                ...state,
                topUpStatusStarted: true
            };
        case GET_TOPUP_STATUS_SUCCESS:
            return {
                ...state,
                topUpStatus: action.payload,
                topUpStatusStarted: false
            };
        case GET_TOPUP_STATUS_FAILURE:
            return {
                ...state,
                topUpStatusErr: action.payload,
                topUpStatusStarted: false
            };
        case CANCEL_TOPUP_STARTED:
            return {
                ...state,
                cancelTopUpStarted: true
            };
        case CANCEL_TOPUP_SUCCESS:
            return {
                ...state,
                cancelTopUpStatus: action.payload,
                cancelTopUpStarted: false
            };
        case CANCEL_TOPUP_FAILURE:
            return {
                ...state,
                cancelTopUpErr: action.payload,
                cancelTopUpStarted: false
            };
        case GET_SYSTEM_UPDATES_STARTED:
            return {
                ...state,
                systemUpdatesStarted: true
            };
        case GET_SYSTEM_UPDATES_SUCCESS:
            return {
                ...state,
                systemUpdates: action.payload?.pagination?.current_page > 1
                    // подгрузка следующей страницы — дописываем в конец списка
                    ? {
                        ...action.payload,
                        updates: [...(state.systemUpdates?.updates || []), ...(action.payload?.updates || [])]
                    }
                    : action.payload,
                systemUpdatesStarted: false
            };
        case GET_SYSTEM_UPDATES_FAILURE:
            return {
                ...state,
                systemUpdatesErr: action.payload,
                systemUpdatesStarted: false
            };
        case GET_DIRECT_TOPUP_INFO_STARTED:
            return {
                ...state,
                directTopUpInfoStarted: true
            };
        case GET_DIRECT_TOPUP_INFO_SUCCESS:
            return {
                ...state,
                directTopUpInfo: action.payload,
                directTopUpInfoStarted: false
            };
        case GET_DIRECT_TOPUP_INFO_FAILURE:
            return {
                ...state,
                directTopUpInfoErr: action.payload,
                directTopUpInfoStarted: false
            };
        case CREATE_DIRECT_TOPUP_STARTED:
            return {
                ...state,
                createDirectTopUpStarted: true
            };
        case CREATE_DIRECT_TOPUP_SUCCESS:
            return {
                ...state,
                directTopUp: action.payload,
                createDirectTopUpErr: false,
                createDirectTopUpStarted: false
            };
        case CREATE_DIRECT_TOPUP_FAILURE:
            return {
                ...state,
                createDirectTopUpErr: action.payload,
                createDirectTopUpStarted: false
            };
        case GET_DIRECT_TOPUP_STARTED:
            return {
                ...state,
                directTopUpStarted: true
            };
        case GET_DIRECT_TOPUP_SUCCESS:
            return {
                ...state,
                directTopUp: action.payload,
                directTopUpStarted: false
            };
        case GET_DIRECT_TOPUP_FAILURE:
            return {
                ...state,
                directTopUpStarted: false
            };
        case CANCEL_DIRECT_TOPUP_STARTED:
            return {
                ...state,
                cancelDirectTopUpStarted: true
            };
        case CANCEL_DIRECT_TOPUP_SUCCESS:
            return {
                ...state,
                directTopUp: action.payload,
                cancelDirectTopUpStarted: false
            };
        case CANCEL_DIRECT_TOPUP_FAILURE:
            return {
                ...state,
                cancelDirectTopUpStarted: false
            };
        case GET_NOTIFICATIONS_STARTED:
            return {
                ...state,
                notificationsStarted: true
            };
        case GET_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: action.payload?.pagination?.current_page > 1 && action.payload?.append
                    // подгрузка следующей страницы в карточке на главной
                    ? {
                        ...action.payload,
                        notifications: [...(state.notifications?.notifications || []), ...(action.payload?.notifications || [])]
                    }
                    : action.payload,
                notificationsStarted: false
            };
        case GET_NOTIFICATIONS_FAILURE:
            return {
                ...state,
                notificationsErr: action.payload,
                notificationsStarted: false
            };
        case READ_NOTIFICATION_SUCCESS:
            return {
                ...state,
                notifications: state.notifications ? {
                    ...state.notifications,
                    unread_count: action.payload?.unread_count,
                    notifications: (state.notifications?.notifications || []).map(item => (
                        item?.id === action.payload?.notification?.id ? action.payload.notification : item
                    ))
                } : state.notifications
            };
        case READ_ALL_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: state.notifications ? {
                    ...state.notifications,
                    unread_count: action.payload?.unread_count,
                    notifications: (state.notifications?.notifications || []).map(item => ({...item, read: true}))
                } : state.notifications
            };
        case SET_WITHDRAW_MODAL_STATUS:
            return {
                ...state,
                withdrawModalStatus: action.payload
            };
        case GET_WITHDRAW_INFO_STARTED:
            return {
                ...state,
                withdrawInfoStarted: true
            };
        case GET_WITHDRAW_INFO_SUCCESS:
            return {
                ...state,
                withdrawInfo: action.payload,
                withdrawInfoStarted: false
            };
        case GET_WITHDRAW_INFO_FAILURE:
            return {
                ...state,
                withdrawInfoErr: action.payload,
                withdrawInfoStarted: false
            };
        case CREATE_WITHDRAW_STARTED:
            return {
                ...state,
                createWithdrawStarted: true
            };
        case CREATE_WITHDRAW_SUCCESS:
            return {
                ...state,
                createWithdrawStatus: action.payload,
                createWithdrawErr: false,
                createWithdrawStarted: false
            };
        case CREATE_WITHDRAW_FAILURE:
            return {
                ...state,
                createWithdrawErr: action.payload,
                createWithdrawStarted: false
            };
        case GET_ENERGY_STARTED:
            return {...state, energyStarted: true}
        case GET_ENERGY_SUCCESS:
            // payload целиком: {energy, unlock:{price, unlocked, unlocked_at}}
            return {...state, energy: action.payload, energyStarted: false}
        case GET_ENERGY_FAILURE:
            return {...state, energyStarted: false}
        case UNLOCK_ENERGY_STARTED:
            return {...state, unlockStarted: true, unlockErr: false}
        case UNLOCK_ENERGY_SUCCESS:
            return {...state, energy: action.payload, unlockStarted: false, unlockErr: false}
        case UNLOCK_ENERGY_FAILURE:
            return {...state, unlockErr: action.payload, unlockStarted: false}
        case GET_METAPERSON_STARTED:
            return {...state, metapersonStarted: true, metapersonErr: false}
        case GET_METAPERSON_SUCCESS:
            return {...state, metaperson: action.payload, metapersonStarted: false}
        case GET_METAPERSON_FAILURE:
            return {...state, metapersonErr: action.payload, metapersonStarted: false}
        case IMPORT_AVATAR_STARTED:
            return {...state, importAvatarStarted: true, importAvatarErr: false}
        case IMPORT_AVATAR_SUCCESS:
            // импорт возвращает тот же объект, что и GET /avatar
            return {...state, avatar: action.payload, importAvatarStarted: false, importAvatarErr: false}
        case IMPORT_AVATAR_FAILURE:
            return {...state, importAvatarErr: action.payload, importAvatarStarted: false}
        case SET_UNLOCK_MODAL_STATUS:
            return {...state, unlockModalStatus: action.payload}
        case SET_ENERGY_MODAL_STATUS:
            return {...state, energyModalStatus: action.payload}
        case SET_CREATOR_STATUS:
            return {...state, creatorStatus: action.payload}
        case GET_VOICE_STARTED:
            return {
                ...state,
                voiceStarted: true
            }
        case GET_VOICE_SUCCESS:
            // в payload весь ответ целиком: {voice, can_upload}
            return {
                ...state,
                voice: action.payload,
                voiceErr: false,
                voiceStarted: false
            }
        case GET_VOICE_FAILURE:
            return {
                ...state,
                voiceErr: action.payload,
                voiceStarted: false
            }
        case UPLOAD_VOICE_STARTED:
            return {
                ...state,
                uploadVoiceStarted: true,
                uploadVoiceErr: false
            }
        case UPLOAD_VOICE_SUCCESS:
            return {
                ...state,
                voice: action.payload,
                uploadVoiceStarted: false,
                uploadVoiceErr: false
            }
        case UPLOAD_VOICE_FAILURE:
            return {
                ...state,
                uploadVoiceErr: action.payload,
                uploadVoiceStarted: false
            }
        case GET_AVATAR_STARTED:
            return {
                ...state,
                avatarStarted: true
            }
        case GET_AVATAR_SUCCESS:
            return {
                ...state,
                // avatar === null пока модель не импортирована — это не ошибка
                avatar: action.payload,
                avatarErr: false,
                avatarStarted: false
            }
        case GET_AVATAR_FAILURE:
            return {
                ...state,
                avatarErr: action.payload,
                avatarStarted: false
            }
        case SET_REFERRAL_WITHDRAW_MODAL_STATUS:
            return {
                ...state,
                referralWithdrawModalStatus: action.payload,
                createReferralWithdrawErr: false
            };
        case GET_REFERRAL_WITHDRAW_INFO_STARTED:
            return {...state, referralWithdrawInfoStarted: true};
        case GET_REFERRAL_WITHDRAW_INFO_SUCCESS:
            return {...state, referralWithdrawInfo: action.payload, referralWithdrawInfoStarted: false};
        case GET_REFERRAL_WITHDRAW_INFO_FAILURE:
            return {...state, referralWithdrawInfoErr: action.payload, referralWithdrawInfoStarted: false};
        case CREATE_REFERRAL_WITHDRAW_STARTED:
            return {...state, createReferralWithdrawStarted: true, createReferralWithdrawErr: false};
        case CREATE_REFERRAL_WITHDRAW_SUCCESS:
            return {
                ...state,
                createReferralWithdrawStatus: action.payload,
                createReferralWithdrawStarted: false,
                createReferralWithdrawErr: false
            };
        case CREATE_REFERRAL_WITHDRAW_FAILURE:
            return {...state, createReferralWithdrawStarted: false, createReferralWithdrawErr: action.payload};
        case GET_REFERRAL_WITHDRAWS_STARTED:
            return {...state, referralWithdrawsStarted: true};
        case GET_REFERRAL_WITHDRAWS_SUCCESS:
            return {...state, referralWithdraws: action.payload, referralWithdrawsStarted: false};
        case GET_REFERRAL_WITHDRAWS_FAILURE:
            return {...state, referralWithdrawsStarted: false};
        case CANCEL_REFERRAL_WITHDRAW_STARTED:
            return {...state, cancelReferralWithdrawStarted: true};
        case CANCEL_REFERRAL_WITHDRAW_SUCCESS:
            return {...state, cancelReferralWithdrawStarted: false};

        case SET_REFERRAL_TRANSFER_MODAL_STATUS:
            return {
                ...state,
                referralTransferModalStatus: action.payload,
                // ошибку прошлой попытки не тащим в новое открытие
                createReferralTransferErr: false
            };
        case SET_REFERRAL_TRANSFERS_MODAL_STATUS:
            return {
                ...state,
                referralTransfersModalStatus: action.payload
            };
        case GET_REFERRAL_TRANSFERS_STARTED:
            return {
                ...state,
                referralTransfersStarted: true
            };
        case GET_REFERRAL_TRANSFERS_SUCCESS:
            return {
                ...state,
                referralTransfers: action.payload?.referral_transfers || [],
                referralTransfersStarted: false
            };
        case GET_REFERRAL_TRANSFERS_FAILURE:
            return {
                ...state,
                referralTransfersStarted: false
            };
        case CREATE_REFERRAL_TRANSFER_STARTED:
            return {
                ...state,
                createReferralTransferStarted: true,
                createReferralTransferErr: false
            };
        case CREATE_REFERRAL_TRANSFER_SUCCESS:
            return {
                ...state,
                createReferralTransferStarted: false,
                createReferralTransferErr: false
            };
        case CREATE_REFERRAL_TRANSFER_FAILURE:
            return {
                ...state,
                createReferralTransferStarted: false,
                createReferralTransferErr: action.payload
            };
        case CANCEL_REFERRAL_TRANSFER_STARTED:
            return {
                ...state,
                cancelReferralTransferStarted: true
            };
        case CANCEL_REFERRAL_TRANSFER_SUCCESS:
            return {
                ...state,
                cancelReferralTransferStarted: false
            };
        case CANCEL_REFERRAL_TRANSFER_FAILURE:
            return {
                ...state,
                cancelReferralTransferStarted: false
            };
        case GET_WITHDRAWS_STARTED:
            return {
                ...state,
                withdrawsStarted: true
            };
        case GET_WITHDRAWS_SUCCESS:
            return {
                ...state,
                withdraws: action.payload,
                withdrawsStarted: false
            };
        case GET_WITHDRAWS_FAILURE:
            return {
                ...state,
                withdrawsStarted: false
            };
        case CANCEL_WITHDRAW_STARTED:
            return {
                ...state,
                cancelWithdrawStarted: true
            };
        case CANCEL_WITHDRAW_SUCCESS:
            return {
                ...state,
                createWithdrawStatus: action.payload,
                cancelWithdrawStarted: false
            };
        case CANCEL_WITHDRAW_FAILURE:
            return {
                ...state,
                cancelWithdrawStarted: false
            };
        case REQUEST_EARLY_ACCESS_STARTED:
            return {...state, earlyAccessStarted: true, earlyAccessErr: false};
        case REQUEST_EARLY_ACCESS_SUCCESS:
            // статус живёт в userData — обновляем его на месте, чтобы страница
            // перерисовалась, не дожидаясь повторного GET /user
            return {
                ...state,
                earlyAccessStarted: false,
                userData: state.userData?.user
                    ? {...state.userData, user: {...state.userData.user, early_access_status: action.payload?.early_access_status}}
                    : state.userData
            };
        case REQUEST_EARLY_ACCESS_FAILURE:
            return {...state, earlyAccessStarted: false, earlyAccessErr: action.payload};

        case SET_STORAGE_MODAL_STATUS:
            return {...state, storageModalStatus: action.payload};
        case GET_STORAGE_STARTED:
            return {...state, storageStarted: true};
        case GET_STORAGE_SUCCESS:
            // {storage:{...}, plans:[{storage_purchase_id, gb, months, ends_at}]}
            return {...state, storageData: action.payload, storageStarted: false};
        case GET_STORAGE_FAILURE:
            return {...state, storageStarted: false};
        case GET_STORAGE_PACKAGES_STARTED:
            return {...state, storagePackagesStarted: true};
        case GET_STORAGE_PACKAGES_SUCCESS:
            // {packages:[{id, gb, storage_bytes, months, price}], currency}
            return {...state, storagePackages: action.payload, storagePackagesStarted: false};
        case GET_STORAGE_PACKAGES_FAILURE:
            return {...state, storagePackagesStarted: false};
        case CREATE_STORAGE_PURCHASE_STARTED:
            return {...state, storagePurchaseStarted: true, storagePurchaseErr: false};
        case CREATE_STORAGE_PURCHASE_SUCCESS:
        case GET_STORAGE_PURCHASE_SUCCESS:
        case CANCEL_STORAGE_PURCHASE_SUCCESS:
            return {...state, storagePurchase: action.payload, storagePurchaseStarted: false, storagePurchaseErr: false};
        case CREATE_STORAGE_PURCHASE_FAILURE:
            return {...state, storagePurchaseStarted: false, storagePurchaseErr: action.payload};

        case GET_ENERGY_PACKAGES_STARTED:
            return {...state, energyPackagesStarted: true};
        case GET_ENERGY_PACKAGES_SUCCESS:
            // {packages:[{id, energy, price}], custom, currency}
            return {...state, energyPackages: action.payload, energyPackagesStarted: false};
        case GET_ENERGY_PACKAGES_FAILURE:
            return {...state, energyPackagesStarted: false};

        case CREATE_ENERGY_PURCHASE_STARTED:
            return {...state, energyPurchaseStarted: true, energyPurchaseErr: false};
        case CREATE_ENERGY_PURCHASE_SUCCESS:
        case GET_ENERGY_PURCHASE_SUCCESS:
        case CANCEL_ENERGY_PURCHASE_SUCCESS:
            return {...state, energyPurchase: action.payload, energyPurchaseStarted: false, energyPurchaseErr: false};
        case CREATE_ENERGY_PURCHASE_FAILURE:
            return {...state, energyPurchaseStarted: false, energyPurchaseErr: action.payload};

        case ASK_CONVERSATION_STARTED:
            return {...state, askStarted: true, askErr: false};
        case ASK_CONVERSATION_SUCCESS:
            // energy в ответе — остаток после списания, держим его свежим
            return {
                ...state,
                askStarted: false,
                energy: state.energy ? {...state.energy, energy: action.payload?.energy} : state.energy
            };
        case ASK_CONVERSATION_FAILURE:
            return {...state, askStarted: false, askErr: action.payload};

        case SPEAK_CONVERSATION_STARTED:
            return {...state, speakStarted: true};
        case SPEAK_CONVERSATION_SUCCESS:
            return {
                ...state,
                speakStarted: false,
                energy: state.energy && action.payload != null
                    ? {...state.energy, energy: action.payload}
                    : state.energy
            };
        case SPEAK_CONVERSATION_FAILURE:
            return {...state, speakStarted: false};

        case GET_CONVERSATIONS_STARTED:
            return {...state, conversationsStarted: true};
        case GET_CONVERSATIONS_SUCCESS:
            return {...state, conversations: action.payload, conversationsStarted: false};
        case GET_CONVERSATIONS_FAILURE:
            return {...state, conversationsStarted: false};

        case GET_CONVERSATION_STARTED:
            return {...state, conversationStarted: true};
        case GET_CONVERSATION_SUCCESS:
            return {...state, conversation: action.payload, conversationStarted: false};
        case GET_CONVERSATION_FAILURE:
            return {...state, conversationStarted: false};

        case SEAL_CAPSULE_STARTED:
            return {...state, sealStarted: true, sealErr: false};
        case SEAL_CAPSULE_SUCCESS:
            return {...state, sealStarted: false};
        case SEAL_CAPSULE_FAILURE:
            return {...state, sealStarted: false, sealErr: action.payload};
        case SET_SEAL_MODAL_STATUS:
            return {...state, sealModalStatus: action.payload, sealErr: false};

        default:
            return state;
    }
}

